/**
 * Intervalo de atualização automática da lista de termos em milissegundos
 * 10 segundos
 */
export const REFRESH_INTERVAL_MS = 10000;

/**
 * Status possíveis para os termos
 */
export const TERM_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  TERM_SIGNED: "TERM_SIGNED",
  TERM_PENDING_SIGNATURE: "TERM_PENDING_SIGNATURE",
  CANCELED: "CANCELED",
} as const;

export type TermStatus = (typeof TERM_STATUS)[keyof typeof TERM_STATUS];

/**
 * Status em que o termo não pode mais ser cancelado — nesses casos o botão
 * "Cancelar Termo" fica oculto.
 */
export const NON_CANCELABLE_TERM_STATUSES: TermStatus[] = [
  TERM_STATUS.REJECTED,
  TERM_STATUS.APPROVED,
  TERM_STATUS.CANCELED,
];

export const TERM_REJECT_TOOLTIPS = {
  TERM: "Informe o motivo da recusa antes de rejeitar.",
  SIGNATURE: "Informe o motivo da recusa antes de rejeitar a assinatura.",
} as const;
